<template>
  <modal
    :name="modalName"
    :adaptive="true"
    height="auto"
    width="446px"
    scrollable
    reset
    @closed="setShowModal(false)"
  >
    <div class="v-modal__inner">
      <DownloadMediaForm />
      <span
        role="button"
        aria-label="Close popup"
        class="v-modal__button--close"
        @click="hideModal"
      />
    </div>
  </modal>
</template>

<script>
import { getCurrentInstance, watch } from 'vue'
import DownloadMediaForm from '@/Redesign/Components/DownloadMedia/DownloadMediaForm.vue'
import useDownloadMedia from '@/Redesign/Compositions/useDownloadMedia'

export default {
  components: {
    DownloadMediaForm
  },
  props: {
    modalName: {
      type: String,
      default: 'download-media-modal'
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance()
    const { modalName } = props
    const { $modal } = proxy
    const {
      state,

      setShowModal
    } = useDownloadMedia()

    const showModal = () => {
      $modal.show(modalName)
    }

    const hideModal = () => {
      $modal.hide(modalName)
    }

    watch(
      () => state.showModal,
      (newVal) => {
        if (newVal) {
          showModal()
        } else {
          hideModal()
        }
      }
    )

    return {
      modalName,

      showModal,
      hideModal,
      setShowModal
    }
  }
}
</script>
